// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2m-q";
export var animationRelative = "_2m-p";
export var backdropBlur = "_2m-0";
export var detailLabelCell = "_2m-12";
export var detailTable = "_2m-11";
export var detailValueCell = "_2m-13";
export var docIconBox = "_2m-1d";
export var docIconBoxMd = "_2m-1f";
export var docIconBoxSm = "_2m-1e";
export var docTypeRow = "_2m-16";
export var docTypeRowInner = "_2m-17";
export var dropdownMatchDatePicker = "_2m-3";
export var evidenceCardContent = "_2m-1c";
export var fileUploadSpin = "_2m-j";
export var gorgiasOpenButton = "_2m-15 _2m-d";
export var gorgiasTicketCard = "_2m-14";
export var heroModalFooterButton = "_2m-18";
export var hiddenContainer = "_2m-o";
export var iconPrimary = "_2m-1g";
export var iconSecondary = "_2m-1h";
export var iconTertiary = "_2m-1i";
export var integrationCard = "_2m-1";
export var integrationLogoBox = "_2m-2";
export var mainColumnSticky = "_2m-1b";
export var maxWidthContainer = "_2m-19";
export var modalContentBody = "_2m-a";
export var modalHeaderImage = "_2m-5";
export var modalImageLabel = "_2m-7";
export var modalImageOverlay = "_2m-6";
export var modalImageSubtitle = "_2m-9";
export var modalImageTitle = "_2m-8";
export var modalImageWrapper = "_2m-4";
export var modalStickyFooter = "_2m-b";
export var removeButton = "_2m-e";
export var sidebarColumn = "_2m-1a";
export var spinner = "_2m-i";
export var timelineLine = "_2m-y";
export var timelineLineBlack = "_2m-10 _2m-y";
export var timelineLineGray = "_2m-z _2m-y";
export var timelineLineHeight = "_2m-x";
export var tlDotActivate = "_2m-u";
export var tlDotActivateAnim = "_2m-t";
export var tlDotHide = "_2m-s";
export var tlDotHideAnim = "_2m-r";
export var tlLineActivate = "_2m-w";
export var tlLineActivateAnim = "_2m-v";
export var uploadHint = "_2m-n";
export var uploadIconBox = "_2m-k";
export var uploadLabel = "_2m-m";
export var uploadText = "_2m-l";
export var uploadZone = "_2m-f";
export var uploadZoneCursorDefault = "_2m-h";
export var uploadZoneCursorPointer = "_2m-g";
export var uploadedFileRow = "_2m-c";
export var viewButton = "_2m-d";